/* The mockup's "Costo por modelo y flujo" card: a head with the toggle, then one table per currency. */
.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.title {
  flex: 1;
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.wrap {
  overflow-x: auto;
}

.caption {
  padding-block-end: var(--space-2);
  color: var(--text-muted);
  font-size: var(--font-size-13);
  text-align: start;
}

.mono {
  font-family: var(--font-mono);
  font-size: var(--font-size-12);
}

.number {
  font-variant-numeric: tabular-nums;
  text-align: end;
}
